module.exports = __webpack_public_path__ + "img/nyyh.fb42a290.png";